import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'card',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="card-component">
            <div
                *ngIf="hasHeader"
                class="card-component-header"
                [ngClass]="{ green: isGreenHeader }"
            >
                <div *ngIf="headerTitle">
                    <h3>{{ headerTitle }}</h3>
                </div>
                <ng-container *ngIf="!headerTitle">
                    <ng-content select="[card-header]"></ng-content>
                </ng-container>
                <div class="left-header-content">
                    <ng-content select="[left-header-content]"></ng-content>
                </div>
                <div class="full-width-header-content">
                    <ng-content select="[full-width-header-content]"></ng-content>
                </div>
                <div class="right-header-content">
                    <ng-content select="[right-header-content]"></ng-content>
                </div>
            </div>
            <div class="card-component-body-content">
                <ng-content select="[card-body]"></ng-content>
            </div>
            <div *ngIf="hasFooter" class="card-component-footer-content">
                <ng-content select="[card-footer]"></ng-content>
            </div>
        </div>
    `
})
export class CardComponent {
    @Input() public headerTitle?: string;
    @Input() public isGreenHeader?: boolean = false;
    @Input() public hasHeader = true;
    @Input() public hasFooter = false;
}
